import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "../../lib/api";
import { Field, Checkbox } from "./Categories";

const Settings = () => {
  const [s, setS] = useState(null);

  useEffect(() => { api.get("/settings").then((r) => setS(r.data)); }, []);

  const save = async (e) => {
    e.preventDefault();
    try {
      await api.put("/settings", s);
      toast.success("Kaydedildi");
    } catch (err) {
      toast.error("Hata");
    }
  };

  if (!s) return <div>Yükleniyor...</div>;

  const toggleFeature = (key, val) => setS({ ...s, activeFeatures: { ...s.activeFeatures, [key]: val } });

  return (
    <form onSubmit={save} className="space-y-8" data-testid="settings-page">
      <header className="flex items-center justify-between">
        <div>
          <h1 className="font-serif text-3xl text-zbeach-dark">Site Ayarları</h1>
          <p className="text-zbeach-muted text-sm mt-1">İşletme bilgileri, içerik, sosyal linkler ve tema.</p>
        </div>
        <button type="submit" className="px-6 py-2.5 rounded-full bg-zbeach-turquoise text-white font-medium text-sm btn-glow" data-testid="settings-save">Kaydet</button>
      </header>

      <Section title="Genel Bilgi">
        <div className="grid grid-cols-2 gap-3">
          <Field label="İşletme Adı" value={s.businessName} onChange={(v) => setS({ ...s, businessName: v })} />
          <Field label="Para Birimi" value={s.currency} onChange={(v) => setS({ ...s, currency: v })} />
          <Field label="Varsayılan Dil" value={s.defaultLanguage} onChange={(v) => setS({ ...s, defaultLanguage: v })} placeholder="tr / en" />
          <Field label="Logo URL" value={s.logo} onChange={(v) => setS({ ...s, logo: v })} />
        </div>
      </Section>

      <Section title="SEO & Sekme Başlığı">
        <div className="grid grid-cols-2 gap-3">
          <Field label="Site Başlığı TR (sekme)" value={s.siteTitleTR} onChange={(v) => setS({ ...s, siteTitleTR: v })} placeholder="Z Beach — Menü" testid="settings-siteTitleTR" />
          <Field label="Site Başlığı EN (sekme)" value={s.siteTitleEN} onChange={(v) => setS({ ...s, siteTitleEN: v })} placeholder="Z Beach — Menu" testid="settings-siteTitleEN" />
          <Field label="Meta Açıklama TR" value={s.metaDescriptionTR} onChange={(v) => setS({ ...s, metaDescriptionTR: v })} testid="settings-metaDescriptionTR" />
          <Field label="Meta Açıklama EN" value={s.metaDescriptionEN} onChange={(v) => setS({ ...s, metaDescriptionEN: v })} testid="settings-metaDescriptionEN" />
          <Field label="Favicon URL" value={s.favicon} onChange={(v) => setS({ ...s, favicon: v })} placeholder="https://...png/ico" testid="settings-favicon" />
          <Field label="OG / Paylaşım Görseli" value={s.ogImage} onChange={(v) => setS({ ...s, ogImage: v })} testid="settings-ogImage" />
        </div>
      </Section>

      <Section title="Hero / Karşılama">
        <div className="grid grid-cols-2 gap-3">
          <Field label="Başlık TR" value={s.heroTitleTR} onChange={(v) => setS({ ...s, heroTitleTR: v })} />
          <Field label="Başlık EN" value={s.heroTitleEN} onChange={(v) => setS({ ...s, heroTitleEN: v })} />
          <Field label="Alt Slogan TR" value={s.heroSubtitleTR} onChange={(v) => setS({ ...s, heroSubtitleTR: v })} />
          <Field label="Alt Slogan EN" value={s.heroSubtitleEN} onChange={(v) => setS({ ...s, heroSubtitleEN: v })} />
          <Field label="Footer Yazısı TR" value={s.footerTextTR} onChange={(v) => setS({ ...s, footerTextTR: v })} />
          <Field label="Footer Yazısı EN" value={s.footerTextEN} onChange={(v) => setS({ ...s, footerTextEN: v })} />
        </div>
      </Section>

      <Section title="İletişim & Sosyal">
        <div className="grid grid-cols-2 gap-3">
          <Field label="Telefon" value={s.phone} onChange={(v) => setS({ ...s, phone: v })} />
          <Field label="WhatsApp" value={s.whatsapp} onChange={(v) => setS({ ...s, whatsapp: v })} />
          <Field label="E-posta" value={s.email} onChange={(v) => setS({ ...s, email: v })} />
          <Field label="Adres" value={s.address} onChange={(v) => setS({ ...s, address: v })} />
          <Field label="Google Maps URL" value={s.mapsUrl} onChange={(v) => setS({ ...s, mapsUrl: v })} />
          <Field label="Instagram URL" value={s.instagramUrl} onChange={(v) => setS({ ...s, instagramUrl: v })} />
          <Field label="TikTok URL" value={s.tiktokUrl} onChange={(v) => setS({ ...s, tiktokUrl: v })} />
          <Field label="Playlist URL" value={s.playlistUrl} onChange={(v) => setS({ ...s, playlistUrl: v })} />
        </div>
      </Section>

      <Section title="Wi-Fi">
        <div className="grid grid-cols-2 gap-3">
          <Field label="Ağ Adı" value={s.wifiName} onChange={(v) => setS({ ...s, wifiName: v })} />
          <Field label="Şifre" value={s.wifiPassword} onChange={(v) => setS({ ...s, wifiPassword: v })} />
        </div>
      </Section>

      <Section title="Aktif Özellikler">
        <p className="text-xs text-zbeach-muted mb-2">Müşteri tarafındaki menüde yan menüden (hamburger) gösterilecek bilgi linkleri.</p>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
          <Checkbox label="Wi-Fi" checked={s.activeFeatures?.wifi} onChange={(v) => toggleFeature("wifi", v)} />
          <Checkbox label="Instagram" checked={s.activeFeatures?.instagram} onChange={(v) => toggleFeature("instagram", v)} />
          <Checkbox label="İletişim" checked={s.activeFeatures?.contact} onChange={(v) => toggleFeature("contact", v)} />
        </div>
      </Section>

      <Section title="Tema Renkleri">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          <ColorField label="Ana Renk" value={s.theme?.primary} onChange={(v) => setS({ ...s, theme: { ...s.theme, primary: v } })} />
          <ColorField label="Vurgu (Altın)" value={s.theme?.accent} onChange={(v) => setS({ ...s, theme: { ...s.theme, accent: v } })} />
          <ColorField label="Arka Plan" value={s.theme?.background} onChange={(v) => setS({ ...s, theme: { ...s.theme, background: v } })} />
          <ColorField label="Yüzey" value={s.theme?.surface} onChange={(v) => setS({ ...s, theme: { ...s.theme, surface: v } })} />
        </div>
      </Section>

      <div className="flex justify-end">
        <button type="submit" className="px-6 py-2.5 rounded-full bg-zbeach-turquoise text-white font-medium text-sm btn-glow">Kaydet</button>
      </div>
    </form>
  );
};

const Section = ({ title, children }) => (
  <section className="bg-zbeach-surface border border-zbeach-gold/15 rounded-2xl p-5">
    <h2 className="font-serif text-xl text-zbeach-dark mb-3">{title}</h2>
    {children}
  </section>
);

const ColorField = ({ label, value, onChange }) => (
  <div>
    <label className="block text-xs uppercase tracking-wider text-zbeach-muted mb-1">{label}</label>
    <div className="flex items-center gap-2">
      <input type="color" value={value || "#000000"} onChange={(e) => onChange(e.target.value)} className="w-10 h-10 rounded-lg border border-zbeach-gold/20" />
      <input value={value || ""} onChange={(e) => onChange(e.target.value)} className="flex-1 px-2 py-2 rounded-lg bg-zbeach-bg border border-zbeach-gold/20 text-sm" />
    </div>
  </div>
);

export default Settings;
